import {
  DraftStatus,
  DraftTransition,
  StatusCategory,
  StatusColor,
} from './types';

/**
 * The structure a new `Foreground` workflow starts with: one status per
 * `StatusCategory`, in the order the board renders them. The board derives its
 * columns from the status list (`useBoardColumns.toDefaultColumns`), so these
 * four statuses are also the four standard columns a freshly created workflow
 * opens with — there is no separate column seed.
 *
 * `color` is a key of the status form's fixed palette, not a CSS value — see
 * `pages/WorkflowBuilder/shared/status/statusColors.ts`.
 */
export const DEFAULT_DRAFT_STATUSES: DraftStatus[] = [
  {
    key: 'to_do',
    name: 'До виконання',
    color: StatusColor.Blue,
    category: StatusCategory.ToDo,
    isInitial: true,
    isFinal: false,
  },
  {
    key: 'in_progress',
    name: 'У роботі',
    color: StatusColor.Yellow,
    category: StatusCategory.InProgress,
    isInitial: false,
    isFinal: false,
  },
  {
    key: 'done',
    name: 'Виконано',
    color: StatusColor.Teal,
    category: StatusCategory.Done,
    isInitial: false,
    isFinal: true,
  },
  {
    key: 'rejected',
    name: 'Відхилено',
    color: StatusColor.Purple,
    category: StatusCategory.Rejected,
    isInitial: false,
    isFinal: true,
  },
];

/**
 * The transitions that make the default statuses a valid process: every
 * non-final status has an outgoing transition and every status is reachable,
 * which is what the structure contract validates on save.
 */
export const DEFAULT_DRAFT_TRANSITIONS: DraftTransition[] = [
  {
    key: 'start',
    name: 'Взяти в роботу',
    fromStatusKey: 'to_do',
    toStatusKey: 'in_progress',
  },
  {
    key: 'finish',
    name: 'Завершити',
    fromStatusKey: 'in_progress',
    toStatusKey: 'done',
  },
  {
    key: 'reject',
    name: 'Відхилити',
    fromStatusKey: null,
    toStatusKey: 'rejected',
  },
];
